import React, { useEffect, useState } from 'react';
import Input from '../Input';
import PasswordInput from '../PasswordInput';
import Modal from '../Modal';
import ExtraUserModal from './ExtraUserModal';
import WebsiteModal from './WebsiteModal';
import SubItem from './SubItem';
import { useConfirm } from '../ConfirmContext';
import * as validation from '../Validation';
import CheckBox from '../CheckBox';
import ChargeModal from './ChargeModal';

import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as PlusIcon } from '../images/plus.svg';

const UserModal = ({setVisible, user, saveUser}) => {
  const confirm = useConfirm();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [telephone, setTelephone] = useState('');
  const [subscription, setSubscription] = useState('450');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [stripeCustomerId, setStripeCustomerId] = useState('');
  const [extraUsers, setExtraUsers] = useState([]);
  const [extraUserModalvisible, setExtraUserModalVisible] = useState(false);
  const [editedExtraUser, setEditedExtraUser] = useState(null);
  const [websites, setWebsites] = useState([]);
  const [websiteModalvisible, setWebsiteModalVisible] = useState(false);
  const [editedWebsite, setEditedWebsite] = useState(null);
  const [copied, setCopied] = useState(false);
  const [passwordOverwritten, setPasswordOverwritten] = useState(false);
  const [trying, setTrying] = useState(false);
  const [chargeModalvisible, setChargeModalVisible] = useState(false);

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setCompany(user.company);
      setTelephone(user.telephone);
      setSubscription(user.subscription);
      setTrying(user.trying);
      setStripeCustomerId(user.stripeCustomerId);
      setPasswordOverwritten(user.passwordOverwritten);
      setWebsites(user.websites);
      setExtraUsers(user.extraUsers);
    }
  }, [user]);

  const saveExtraUser = ({email, password}) => {
    let newUsers;

    if (editedExtraUser) {
      let index = extraUsers.findIndex((user) => {
        return user.id === editedExtraUser.id;
      });

      newUsers = [...extraUsers];

      if (password !== '') {
        newUsers[index].password = password;
        newUsers[index].resetPassword = true;
      }

      newUsers[index].email = email;
      newUsers[index].modified = true;
    }
    else {
      newUsers = [...extraUsers, {email,
                                  password,
                                  modified: true,
                                  resetPassword: true}];
    }

    setExtraUsers(newUsers);
  }

  const saveWebsite = ({domain, detection, slowRetraining, config}) => {
    setWebsites((prev) => {
      const newWebsites = [...prev];
      if (editedWebsite) {
        const index = newWebsites.findIndex((website) => {
          return website.domain === editedWebsite.domain;
        });
        if (index !== -1) {
          newWebsites[index].domain = domain;
          newWebsites[index].detection = detection;
          newWebsites[index].slowRetraining = slowRetraining;
          newWebsites[index].modified = true;
          newWebsites[index].config = config;
        }
      } else {
        let config = { action: 'ignore',
                       is_active: false,
                       rules: []
                     };
        newWebsites.push({domain, detection, slowRetraining, modified: true, config});
      }
      return newWebsites;
    });
  }

  const getDetectionString = (label) => {
    return label
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const create = async () => {
    if (validation.getNameWarning(name)) {
      await confirm('Please use a valid name', true);
      return;
    }
    if (validation.getEmailWarning(email)) {
      await confirm('Please enter a valid email address', true);
      return;
    }
    if (validation.getPasswordWarning(password, null)) {
      await confirm('Please enter a valid password', true);
      return;
    }
    if (validation.getPasswordWarning(confirmPassword, password)) {
      await confirm('Please confirm your password correctly', true);
      return;
    }

    saveUser(user?.index, {name,
                           email,
                           company,
                           telephone,
                           subscription,
                           extraUsers,
                           websites,
                           password,
                           stripeCustomerId,
                           passwordOverwritten,
                           trying
                          });
    setVisible(false);
  }

  return (
    <>
      {extraUserModalvisible && (
        <ExtraUserModal setVisible={setExtraUserModalVisible}
                        extraUser={editedExtraUser}
                        extraUsers={extraUsers}
                        saveExtraUser={saveExtraUser} />
      )}

      {websiteModalvisible && (
        <WebsiteModal setVisible={setWebsiteModalVisible}
                      website={editedWebsite}
                      websites={websites}
                      saveWebsite={saveWebsite} />
      )}

      {chargeModalvisible && (
        <ChargeModal
          setVisible={setChargeModalVisible}
          userId={user.id}
        />
      )}

      <Modal isOpen={true}
             zIndex={100}>
        <div style={{
               background: 'linear-gradient(gray, transparent)',
               position: 'absolute',
               transform: 'translate(-50%, -50%)',
               top: '50%',
               left: '50%',
               width: '600px',
               borderRadius: '10px',
               maxHeight: '90vh',
               overflow: 'auto',
             }}>
          <div
            style={{
              margin: '1px',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              padding: '20px',
              backgroundColor: 'black',
            }}>
            <div style={{
                   display: 'flex',
                   flexDirection: 'row',
                   alignItems: 'center',
                   justifyContent: 'space-between',
                   width: '100%',
                 }}>
              <span style={{fontSize: '22px',
                            fontWeight: 'bold',
                           }}>
                {user ? 'Edit User' : 'Add User'}
              </span>

              <CloseIcon className='image'
                         style={{width: '15px',
                                 height: '15px',
                                 fill: 'white',
                                }}
                         onClick={() => setVisible(false)} />
            </div>

            <Input label='NAME'
                   value={name}
                   onChange={(e) => setName(e.target.value)} />

            <Input label='EMAIL'
                   value={email}
                   onChange={(e) => setEmail(e.target.value)} />

            <Input label='COMPANY'
                   value={company}
                   onChange={(e) => setCompany(e.target.value)} />

            <Input label='TELEPHONE'
                   value={telephone}
                   onChange={(e) => setTelephone(e.target.value)} />

            <select style={{padding: '15px',
                            backgroundColor: 'transparent',
                            border: '1px solid #d3d3d3',
                            borderRadius: '5px',
                            fontSize: '16px',
                            color: 'white',
                            marginTop: '10px',
                           }}
                    value={subscription}
                    onChange={(e) => {
                      setSubscription(e.target.value);
                    }}>
              {['450', '800', '1500', '2500',
                '4500', '6000', '9600', '19500',
                'Unlimited', 'Canceled', 'Legacy'].map((tier, index) => {
                  // Legacy is not a state an account can be moved into, it
                  // just means the account has no subscriptions2 row and is
                  // still billed through the old system. Offer it only to the
                  // accounts already on it, so it reads as a label rather than
                  // a choice.
                  const legacyUnavailable = tier === 'Legacy' &&
                        user?.subscription !== 'Legacy';

                  return (
                    <option key={index}
                            value={tier}
                            disabled={legacyUnavailable}>{isNaN(parseInt(tier)) ? '' : '$'}
                      {tier}
                    </option>
                  );
                })}
            </select>

            {trying && (
              <div style={{marginTop: '15px',
                           display: 'flex',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           padding: '5px 10px',
                           backgroundColor: 'gray',
                           borderRadius: '5px',
                           width: 'fit-content',
                          }}
                   onClick={() => {
                     setTrying(false);
                   }}>
                <span style={{color: 'white',
                              fontSize: '16px',
                              fontWeight: 'bold',
                             }}>
                  Give up subscription
                </span>
              </div>
            )}

            <PasswordInput label='PASSWORD'
                           onChange={(e) => setPassword(e.target.value)}
                           showWarning={true}/>

            <PasswordInput label='CONFIRM PASSWORD'
                           target={password}
                           onChange={(e) => setConfirmPassword(e.target.value)}
                           showWarning={true}/>

            <Input label='STRIPE CUSTOMER ID'
                   value={stripeCustomerId}
                   onChange={(e) => setStripeCustomerId(e.target.value)} />

            <div style={{display: 'flex',
                         gap: '10px',
                         alignItems: 'center',
                         marginTop: '20px',
                        }}>
              <CheckBox
                checked={passwordOverwritten}
                onChange={(e) => {
                  setPasswordOverwritten(e.target.checked);
                }}/>

              <span style={{color: 'gray',
                            fontSize: '13px',
                           }}>
                Password Overwritten?
              </span>
            </div>

            <div style={{color: 'white',
                         marginTop: '15px',
                         display: 'flex',
                         justifyContent: 'space-between',
                         alignItems: 'center',
                         padding: '5px 10px',
                        }} >
              <span style={{color: 'white',
                            fontSize: '16px',
                            fontWeight: 'bold',
                           }}>
                Websites
              </span>
              <PlusIcon className='image'
                        style={{width: '15px',
                                height: '15px',
                                fill: 'white',
                                cursor: 'pointer',
                               }}
                        onClick={() => {
                          setEditedWebsite(null);
                          setWebsiteModalVisible(true);
                        }} />
            </div>

            <div style={{minHeight: '20px'}}>
              {websites
               .filter((website) => !website.deleted)
               .map((website, index) => {
                return (
                  <div key={index} >
                    <SubItem text={website.domain}
                             text2={getDetectionString(website.detection)}
                             slow={website.slowRetraining}
                             edited={() => {
                               setEditedWebsite(website);
                               setWebsiteModalVisible(true);
                             }}
                             deleted={async () => {
                               const confirmed = await confirm(`Are you sure you want to delete website ${website.domain}?`);
                               if (confirmed) {
                                 setWebsites((prev) => {
                                   let newWebsites = [...prev];
                                   newWebsites[index].deleted = true;
                                   return newWebsites;
                                 });
                               }
                             }} />
                  </div>
                )})}
            </div>

            <div style={{color: 'white',
                         marginTop: '15px',
                         display: 'flex',
                         justifyContent: 'space-between',
                         alignItems: 'center',
                         padding: '5px 10px',
                        }} >
              <span style={{color: 'white',
                            fontSize: '16px',
                            fontWeight: 'bold',
                           }}>
                Extra Users
              </span>
              <PlusIcon className='image'
                        style={{width: '15px',
                                height: '15px',
                                fill: 'white',
                                cursor: 'pointer',
                               }}
                        onClick={() => {
                          setEditedExtraUser(null);
                          setExtraUserModalVisible(true);
                        }} />
            </div>

            <div style={{minHeight: '20px'}}>
              {extraUsers
               .filter((user) => !user.deleted)
               .map((user, index) => {
                return (
                  <div key={index} >
                    <SubItem text={user.email}
                             edited={() => {
                               setEditedExtraUser(user);
                               setExtraUserModalVisible(true);
                             }}
                             deleted={async () => {
                               const confirmed = await confirm(`Are you sure you want to delete extra user ${user.email}?`);
                               if (confirmed) {
                                 setExtraUsers((prev) => {
                                   let newExtraUsers = [...prev];
                                   newExtraUsers[index].deleted = true;
                                   return newExtraUsers;
                                 });
                               }
                             }} />
                  </div>
                )})}
            </div>

            {user && (
              <div style={{marginTop: '15px',
                           display: 'flex',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           padding: '5px 10px',
                           backgroundColor: 'gray',
                           borderRadius: '5px',
                           width: 'fit-content',
                          }}
                   onClick={async () => {
                     const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/create-payment-link', {
                       method: 'POST',
                       headers: {
                         'Authorization': localStorage.getItem('token'),
                         'Content-Type': 'application/json',
                       },
                       body: JSON.stringify({ id: user.id }),
                     });

                     const data = await response.json();
                     if (!data.success) return;

                     const queryString = new URLSearchParams({ token: data.token }).toString();
                     let link = process.env.REACT_APP_CLIENT_URL + '/payment' + '?' + queryString;

                     navigator.clipboard.writeText(link);
                     setCopied(true);
                   }}>
                <span style={{color: 'white',
                              fontSize: '16px',
                              fontWeight: 'bold',
                             }}>
                  {copied ? 'Copied!' : 'Copy payment link'}
                </span>
              </div>
            )}

            {user && (
              <div style={{marginTop: '15px',
                           display: 'flex',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           padding: '5px 10px',
                           backgroundColor: 'gray',
                           borderRadius: '5px',
                           width: 'fit-content',
                          }}
                   onClick={() => {
                     setChargeModalVisible(true);
                   }}>
                <span style={{color: 'white',
                              fontSize: '16px',
                              fontWeight: 'bold',
                             }}>
                  Charge now
                </span>
              </div>
            )}

            <div style={{display: 'flex',
                         flexDirection: 'row',
                         alignItems: 'center',
                         marginTop: '10px',
                         gap: '10px',
                         justifyContent: 'center',
                        }}>
              <div style={{alignItems: 'center',
                           padding: '10px 20px',
                           border: '1px solid #e0e0e0',
                           borderRadius: '5px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           alignSelf: 'flex-end',
                           display: 'flex',
                           justifyContent: 'center',
                          }}
                   onClick={() => setVisible(false)}>
                Cancel
              </div>
              <div style={{alignItems: 'center',
                           padding: '10px 20px',
                           backgroundColor: '#009de6',
                           color: 'white',
                           borderRadius: '5px',
                           cursor: 'pointer',
                           fontWeight: 'bold',
                           alignSelf: 'flex-end',
                           display: 'flex',
                           justifyContent: 'center',
                          }}
                   onClick={() => create()}>
                {user ? 'Save' : 'Add'}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default UserModal;
